export default __webpack_public_path__ + "static/media/css01.eae7c514.PNG";